import { render, staticRenderFns } from "./configurationList.vue?vue&type=template&id=7799a10a&scoped=true"
import script from "./configurationList.vue?vue&type=script&lang=js"
export * from "./configurationList.vue?vue&type=script&lang=js"
import style0 from "./configurationList.vue?vue&type=style&index=0&id=7799a10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799a10a",
  null
  
)

export default component.exports